/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import log from 'loglevel';
import posthog from 'posthog-js';

log.setLevel(log.levels.DEBUG);

// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const serializeArguments = (arguments_: any[]): any[] => {
  try {
    return arguments_.map((argument) => {
      if (argument === null || argument === undefined) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return argument;
      }
      if (
        typeof argument === 'string' ||
        typeof argument === 'number' ||
        typeof argument === 'boolean'
      ) {
        return argument;
      }
      if (argument instanceof Error) {
        return {
          name: argument.name,
          message: argument.message,
          stack: argument.stack,
        };
      }

      try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return JSON.parse(JSON.stringify(argument));
      } catch {
        return String(argument);
      }
    });
  } catch {
    return arguments_.map(String);
  }
};

const shouldIgnoreForPostHog = (message: unknown, arguments_: any[]): boolean => {
  const error = message instanceof Error ? message : arguments_[0];
  if (
    message.includes('performance/invalid') ||
    (message.includes('Performance') && message.includes('invalid'))
  ) {
    return true;
  }
  if (error instanceof Error && error.name === 'AxiosError' && error.message === 'Network Error') {
    return true;
  }
  if (typeof message === 'string' && message.includes('Network Error')) return true;
  return false;
};

const logger = {
  debug(message: string, ...arguments_: any[]) {
    console.debug(message, ...arguments_);
  },

  info(message: string, ...arguments_: any[]) {
    console.info(message, ...arguments_);
  },

  warn(message: string, ...arguments_: any[]) {
    console.warn(message, ...arguments_);
  },

  error(message: string, ...arguments_: any[]) {
    console.error(message, ...arguments_);
    if (!shouldIgnoreForPostHog(message, arguments_)) {
      posthog.captureException(message, {
        message,
        arguments: serializeArguments(arguments_),
      });
    }
  },

  log(message: string, ...arguments_: any[]) {
    console.log(message, ...arguments_);
  },
};

export default logger;
